import { Helmet } from "react-helmet-async"
import {
	ITransportServiceProvider,
	TransportServiceProviderAccountings,
} from "./../../../../TransportServiceProviders"
import { useOutletContext } from "react-router"

export default function TransportServiceProviderAccountingsPage() {
	const { transportServiceProvider } = useOutletContext<{
		transportServiceProvider: ITransportServiceProvider
		revalidate: () => void
	}>()
	return (
		<>
			<Helmet>
				<title>Accounting | TSP</title>
			</Helmet>
			<TransportServiceProviderAccountings
				transportServiceProvider={transportServiceProvider}
			/>
		</>
	)
}
